import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-act-statutes-ordinances',
    templateUrl: './act-statutes-ordinances.component.html',
    styleUrls: ['./act-statutes-ordinances.component.scss'],
    standalone: true,
    imports :[ NgClass],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({opacity: 0, transform: 'translateY(-15px)'}), // More movement for smoothness
                animate(
                    '500ms cubic-bezier(0.25, 0.8, 0.25, 1)',
                    style({opacity: 1, transform: 'translateY(0)'})
                ),
            ]),
            transition(':leave', [
                animate(
                    '400ms cubic-bezier(0.4, 0, 0.2, 1)',
                    style({opacity: 0, transform: 'translateY(-15px)'})
                ),
            ]),
        ]),
    ],
})
export class ActStatutesOrdinancesComponent implements OnInit {
    pageTitle = '';
    activeIndex: number | null = null;
    actSections: any[] = [
        {
            heading: 'Act',
            content: '<p class="text-[12px] text-red-500 underline ml-3">\n' +
                '                    <i class="fa-solid fa-file-pdf mr-2"></i> UP University Act 2025\n' +
                '                </p>'
        }
    ];

    bestPracticesSections: any[] = [
        {
            heading: 'Community Engagement',
            content: '<p class="text-[12px] text-red-500 underline ml-6">\n' +
                '                    <i class="fa-solid fa-file-pdf mr-2"></i> 2024-25' +
                '                </p>'
        },
        {
            heading: 'Green Practices',
            content: '<p class="text-[12px] text-red-500 underline ml-6">\n' +
                '                    <i class="fa-solid fa-file-pdf mr-2"></i> 2024-25' +
                '                </p>'
        }
    ];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.route.data.subscribe(data => {
            this.pageTitle = data.title;
        });
    }

    ngOnInit(): void {
    }

    selectSection(section: string) {
        this.pageTitle = section;
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }
}
